export default __webpack_public_path__ + "static/media/minivan-car.cd77a16a.svg";